import { render, staticRenderFns } from "./LinksAddEdit.vue?vue&type=template&id=37e4d3e9&"
import script from "./LinksAddEdit.vue?vue&type=script&lang=js&"
export * from "./LinksAddEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports